import React, { useState, useEffect } from "react";
import logo from "../../assets/images/weviira.png";
import Swal from "sweetalert2";

import {
  deleteFunction,
} from "../../Component/function/FunctionApi";
import "./Invoices.css";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
} from "@mui/material";

import { getCookie } from "../Login/Login";

import usePrintInvoice from "../../hooks/invoice/printInvoice";
import useShowInvoice from "../../hooks/invoice/ShowInvoice";
import InvoiceDialog from "../../Component/EditInvoice/EditInvoice";
import ItemModal from "../../Component/EditItem/EditItem";
import InvoicesTable from "../../Component/invoicePage/Invoices";
import InvoiceFilters from "../../Component/invoicePage/InvoiceFilters.jsx";
import Pagination from "../../Component/invoicePage/Pagination.jsx";
import useInvoicesSearch from "../../hooks/invoice/useInvoicesSearch";
import {
  addInvoiceCategory,
  updateInvoiceCategories,
  getInvoiceById,
  updateInvoice,
  deleteInvoice,
  getCategories,
  getGovernorates,
  getPhoneNumbers,
  getRepresentatives,
  deleteInvoiceCategoryById,
} from "../../services/invoices";

const getToken = () => {
  const userCookie = getCookie("user");
  return userCookie ? JSON.parse(userCookie).token : null;
};

const Invoices = () => {
  const { handlePrintInvoice } = usePrintInvoice(logo);
  const { showInvoice } = useShowInvoice();
  const [representatives, setRepresentatives] = useState([]);
  const [categories, setCategories] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogType, setDialogType] = useState("");
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [selectedInvoiceItems, setSelectedInvoiceItems] = useState([]);
  const [governorates, setGovernorates] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [numbers, setNumbers] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [newItem, setNewItem] = useState({
    categoryId: "",
    quantity: 0,
    price: 0,
    discount: 0,
  });

  const {
    filters,
    invoicesData,
    handleFilterChange,
    handleClearSearch,
    handlePageChange,
    fetchInvoices,
    isLoading,
  } = useInvoicesSearch(10);

  const handleDeleteItem = async (item) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this item!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      await deleteInvoiceCategoryById(item.id);
      setSelectedInvoiceItems((prev) => prev.filter((i) => i.id !== item.id));

      const response = await getInvoiceById(selectedInvoice.id);
      setSelectedInvoice(response.data);
      setSelectedInvoiceItems(response.data.invoiceCategories);

      await fetchInvoices(invoicesData.currentPage);

      Swal.fire("Deleted!", "Your file has been deleted.", "success");
    }
  };

  const printInvoice = (invoice) => {
    handlePrintInvoice(invoice);
  };

  const handleSaveItem = async (e) => {
    e.preventDefault();
    try {
      const arr = [
        {
          id: newItem.categoryId,
          quantity: newItem.quantity,
          price: newItem.price,
          discount: newItem.discount,
        },
      ];
      await addInvoiceCategory(selectedInvoice.id, arr);

      handleCloseModal();
      Swal.fire({
        title: "Success",
        text: "Item added successfully!",
        icon: "success",
        timer: 3000,
        timerProgressBar: true,
      }).then(async () => {
        const response = await getInvoiceById(selectedInvoice.id);
        setSelectedInvoice(response.data);
        setSelectedInvoiceItems(response.data.invoiceCategories);
        await fetchInvoices(invoicesData.currentPage);
      });
    } catch (e) {
      console.error("Error saving item:", e);
      Swal.fire("Error", "Failed to save the item. Please try again.", "error");
    }
  };

  const handleEditItemRequest = async (e) => {
    e.preventDefault();
    try {
      const arr = [
        {
          invoiceCategoryId: newItem.id,
          categoryId: newItem.categoryId,
          quantity: newItem.quantity,
          price: newItem.price,
          discount: newItem.discount,
        },
      ];
      await updateInvoiceCategories(selectedInvoice.id, arr);

      handleCloseModal();
      Swal.fire({
        title: "Success",
        text: "Item updated successfully!",
        icon: "success",
        timer: 3000,
        timerProgressBar: true,
      }).then(async () => {
        const response = await getInvoiceById(selectedInvoice.id);
        setSelectedInvoice(response.data);
        setSelectedInvoiceItems(response.data.invoiceCategories);
        await fetchInvoices(invoicesData.currentPage);
      });
    } catch (e) {
      console.error("Error saving item:", e);
      Swal.fire("Error", "Failed to save the item. Please try again.", "error");
    }
  };

  const handleEditItem = (item) => {
    setNewItem({
      categoryId: item.categoryId || "",
      quantity: item.quantity || 0,
      price: item.price || 0,
      discount: item.discount || 0,
      id: item.id,
    });
    setEditMode(true);
    setIsModalOpen(true);
  };

  const handleCategoryChange = (e) => {
    const selectedCategory = categories.find(
      (category) => category.id === parseInt(e.target.value)
    );

    setNewItem({
      ...newItem,
      categoryId: selectedCategory.id,
    });
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setNewItem({ id: "", quantity: 0, price: 0, discount: 0 });
  };

  useEffect(() => {
    const bootstrap = async () => {
      try {
        const reps = await getRepresentatives();
        setRepresentatives(reps);
        const cats = await getCategories();
        setCategories(cats.data);
        const nums = await getPhoneNumbers();
        setNumbers(nums.data);
        const govs = await getGovernorates();
        setGovernorates(govs.data);
      } catch (error) {
        console.error("Bootstrap data fetch failed", error);
      }
    };
    bootstrap();
  }, []);

  const handleOpenDialog = (invoice) => {
    setSelectedInvoice(invoice);
    setSelectedInvoiceItems(invoice.invoiceCategories);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleSaveChanges = async () => {
    try {
      const response = await updateInvoice(selectedInvoice.id, selectedInvoice);

      if (response.status === 200) {
        setDialogMessage("تم تحديث الفاتورة بنجاح!");
        setDialogType("success");
      } else {
        setDialogMessage("فشل في تحديث الفاتورة. حاول مرة أخرى.");
        setDialogType("error");
      }
      Swal.fire({
        title: "Success!",
        text: "Item was added successfully to the invoice.",
        icon: "success",
        confirmButtonText: "OK",
        timer: 3000,
        customClass: {
          confirmButton: "swal-confirm-btn",
        },
      });
      setTimeout(async () => {
        await fetchInvoices(invoicesData.currentPage);
      }, 100);
    } catch (error) {
      console.error("Error updating invoice:", error);
      setDialogMessage("حدث خطأ. حاول مرة أخرى.");
      setDialogType("error");
    }
  };

  const handleClose = () => {
    fetchInvoices(invoicesData.currentPage);
    setDialogOpen(false);
    window.location.reload();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedInvoice((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDelete = async (invoice) => {
    try {
      const result = await Swal.fire({
        title: "هل أنت متأكد؟",
        text: "لا يمكنك التراجع عن هذا الإجراء بعد الحذف!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#e63946",
        cancelButtonColor: "#457b9d",
        confirmButtonText: "نعم، احذفها!",
        cancelButtonText: "إلغاء",
      });

      if (result.isConfirmed) {
        await deleteInvoice(invoice.id);
        await fetchInvoices(invoicesData.currentPage);
      }
    } catch (error) {
      console.error("Error deleting invoice:", error);
      Swal.fire(
        "Error!",
        "An unexpected error occurred.",
        error?.response?.data?.message || ""
      );
    }
  };

  return (
    <div className="invoices-container">
      <h2>فواتير</h2>
      <hr />
      <InvoiceFilters
        filters={filters}
        onFilterChange={handleFilterChange}
        onClear={handleClearSearch}
      />
      <div className="table-container" style={{ position: "relative" }}>
        {isLoading && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(255,255,255,0.6)",
              zIndex: 1,
            }}
          >
            <CircularProgress />
          </div>
        )}
        <div className="scrollable-table" style={{ filter: isLoading ? "blur(1px)" : "none" }}>
          <InvoicesTable
            currentInvoices={invoicesData.data || []}
            handlePrintInvoice={handlePrintInvoice}
            handleOpenDialog={handleOpenDialog}
            handleDelete={handleDelete}
            showInvoice={showInvoice}
          />
        </div>

        <InvoiceDialog
          openDialog={openDialog}
          selectedInvoice={selectedInvoice}
          governorates={governorates}
          representatives={representatives}
          selectedInvoiceItems={selectedInvoiceItems}
          handleInputChange={handleInputChange}
          handleCloseDialog={handleCloseDialog}
          setSelectedInvoice={setSelectedInvoice}
          handleSaveChanges={handleSaveChanges}
          handleDeleteItem={handleDeleteItem}
          handleEditItem={handleEditItem}
          setIsModalOpen={setIsModalOpen}
          handleaddItem={() => {
            setEditMode(false);
            setIsModalOpen(true);
          }}
        />
        <ItemModal
          isModalOpen={isModalOpen}
          handleCloseModal={handleCloseModal}
          editMode={editMode}
          newItem={newItem}
          setNewItem={setNewItem}
          categories={categories}
          handleCategoryChange={handleCategoryChange}
          handleEditItemRequest={handleEditItemRequest}
          handleSaveItem={handleSaveItem}
        />

        <Pagination
          currentPage={invoicesData.currentPage || 1}
          totalPages={invoicesData.totalPages || 1}
          onPageChange={handlePageChange}
        />
      </div>
      <Dialog open={dialogOpen} onClose={handleClose}>
        <DialogTitle>
          {dialogType === "success" ? "Success" : "Error"}
        </DialogTitle>
        <DialogContent>
          <h3 className="text-center p-2 ">{dialogMessage}</h3>
        </DialogContent>
        <DialogActions>
          <button
            className="bg-blue-500 text-white py-2 px-4 rounded-md"
            onClick={handleClose}
            color="primary"
          >
            Close
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Invoices;
